import Vue, { VueConstructor } from 'vue'

export default function(__Vue: VueConstructor<Vue>) {
  function buryPointInit(this: Vue) {
    const options = this.$options

    if (options.buryPoint) {
      this.$buryPoint = options.buryPoint
    } else if (options.parent && options.parent.$buryPoint) {
      this.$buryPoint = options.parent.$buryPoint
    }
  }


  __Vue.mixin({ beforeCreate: buryPointInit })
}
